<template>
    <div class="quick-view__wrapper" v-if="showModal && loadedItem">
        <div class="modal fade quick-view__modal" @click="closeQuickView($event.target)" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="quick-view__close" @click="closeQuickView()">
                            <svg width="18" height="18">
                                <use xlink:href="#svg_close-basketmodal" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                            </svg>
                        </div>
                        <div class="row">
                            <div class="col-7">
                                <item-image-carousel :item-data="currentVariation"
                                                     :plugin-path="pluginPathCeres"
                                                     image-url-accessor="url">
                                </item-image-carousel>
                            </div>
                            <div class="col-5">
                                <div class="quick-view__right-side">
                                    <div class="quick-view__name">{{ currentVariation | itemName }}</div>
                                    <div class="quick-view__price">
                                        <span v-if="currentVariation.prices.rrp && currentVariation.prices.rrp.price.value > 0 && currentVariation.prices.rrp.price.value > currentVariation.prices.default.unitPrice.value"
                                              class="crossprice-cat-rebate mr-2">
                                            <del class="crossprice" v-if="currentVariation.prices.specialOffer">
                                                {{ currentVariation.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                                            </del>
                                            <del class="crossprice" v-else>
                                                {{ currentVariation.prices.rrp.unitPrice.formatted }}
                                            </del>
                                        </span>
                                        <span class="price">
                                            {{ currentVariation.prices.default.unitPrice.formatted | specialOffer(currentVariation.prices, "unitPrice", "formatted") }}
                                        </span>
                                    </div>
                                    <span class="vat small">
                                        {{ $translate("Froschkoenig::Template.singleVat1") }} {{ $translate("Froschkoenig::Template.singleVat2") }}
                                    </span>

                                    <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                                                 :bundle-type="currentVariation.variation.bundleType"
                                                 :bundle-components="currentVariation.bundleComponents">
                                    </item-bundle>

                                    <hr>

                                    <p class="single__stock" v-if="currentVariation.stock.net > 0">
                                        <span v-if="currentVariation.stock.net > 10">
                                            <div class="stock-indicator stock-indicator-green"></div>
                                            {{ $translate("Froschkoenig::Template.singleStockMoreThan10") }}
                                        </span>
                                        <span v-else>
                                            <div class="stock-indicator stock-indicator-red"></div>
                                            {{ $translate("Froschkoenig::Template.singleStockOnly1") }} {{ currentVariation.stock.net }} {{ $translate("Froschkoenig::Template.singleStockOnly2") }}
                                        </span>
                                    </p>

                                    <table class="table single__details-table">
                                        <tbody>
                                        <tr>
                                            <td class="single__td-label">
                                                {{ $translate("Ceres::Template.singleItemNumber") }}
                                            </td>
                                            <td>{{ currentVariation.item.id }}</td>
                                        </tr>
                                        <tr>
                                            <td class="single__td-label">
                                                {{ $translate("Ceres::Template.singleItemDimensions") }}
                                            </td>
                                            <td v-html="currentVariation.item.free9"></td>
                                        </tr>
                                        <tr>
                                            <td class="single__td-label">
                                                {{ $translate("Froschkoenig::Template.singleItemLieferzeit") }}
                                            </td>
                                            <td :class="'single__availability-label-' + currentVariation.variation.availability.id">
                                                {{ currentVariation.variation.availability.names.name }}
                                            </td>
                                        </tr>
                                        <tr class="hidden toggle-hidden">
                                            <td class="single__td-label">
                                                {{ $translate("Froschkoenig::Template.singleShippingInfo") }}
                                            </td>
                                            <td>
                                                <a data-toggle="modal"
                                                   @mouseover.once="$store.dispatch('loadComponent', 'shippingscosts-modal')"
                                                   href="#shippingscosts">
                                                    {{ $translate("Froschkoenig::Template.singleShippingInfoShow") }}
                                                </a>
                                            </td>
                                        </tr>
                                        <tr class="hidden toggle-hidden"
                                            v-if="currentVariation.variation.weightG > 0">
                                            <td class="single__td-label">
                                                {{ $translate("Froschkoenig::Template.singleShippingWeight") }}
                                            </td>
                                            <td>{{ currentVariation.variation.weightG / 1000 }} kg</td>
                                        </tr>
                                        <tr class="hidden toggle-hidden">
                                            <td class="single__td-label">
                                                {{ $translate("Froschkoenig::Template.singleShippingCondition") }}
                                            </td>
                                            <td v-html="currentVariation.item.free6">
                                            </td>
                                        </tr>
                                        <tr class="hidden toggle-hidden">
                                            <td class="single__td-label">
                                                {{ $translate("Froschkoenig::Template.singleShippingInfoDetails") }}
                                            </td>
                                            <td v-html="currentVariation.item.free5"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <template v-if="!hasPaketOrSpeditionProp">
                                        <template v-if="has304Prop">
                                            <a class="shippinginfo-link"
                                               data-toggle="modal"
                                               @click="injectPricesIntoModal()"
                                               href="#shippinginfo-304">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spedition-no-text"></use>
                                                </svg>
                                                {{ $translate("Froschkoenig::Template.shippinginfoMontage") }}
                                                <svg role="img" class="svg-icon__icon"
                                                     focusable="false" viewBox="0 0 22 22"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"></path>
                                                    <path d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"></path>
                                                </svg>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a class="shippinginfo-link"
                                               data-toggle="modal"
                                               @click="injectPricesIntoModal()"
                                               href="#shippinginfo-302">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spedition-no-text"></use>
                                                </svg>
                                                {{ $translate("Froschkoenig::Template.shippinginfoSpedNoMontage") }}
                                                <svg role="img" class="svg-icon__icon"
                                                     focusable="false" viewBox="0 0 22 22"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"></path>
                                                    <path d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"></path>
                                                </svg>
                                            </a>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-for="prop in varProps">
                                            <template v-if="prop.values.selectionId == 302 || prop.values.selectionId == 303">
                                                <a class="shippinginfo-link"
                                                   data-toggle="modal"
                                                   @click="injectPricesIntoModal()"
                                                   :href="hasShippingPrices ? '#shippinginfo-302-prices' : '#shippinginfo-302'">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spedition-no-text"></use>
                                                    </svg>
                                                    <template v-if="hasShippingPrices">
                                                        {{ $translate("Froschkoenig::Template.shippinginfoSpedMontage") }}
                                                    </template>
                                                    <template v-else>
                                                        {{ $translate("Froschkoenig::Template.shippinginfoSpedNoMontage") }}
                                                    </template>
                                                    <svg role="img" class="svg-icon__icon"
                                                         focusable="false" viewBox="0 0 22 22"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"></path>
                                                        <path d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"></path>
                                                    </svg>
                                                </a>
                                            </template>
                                            <template v-else-if="prop.values.selectionId == 301">
                                                <a class="shippinginfo-link" data-toggle="modal" @click="injectPricesIntoModal()"
                                                   :href="hasShippingPrices ? '#shippinginfo-301-prices' : '#shippinginfo-301'">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spedition-no-text"></use>
                                                    </svg>
                                                    <template v-if="hasShippingPrices">
                                                        {{ $translate("Froschkoenig::Template.shippinginfoPaketMontage") }}
                                                    </template>
                                                    <template v-else>
                                                        {{ $translate("Froschkoenig::Template.shippinginfoPaketNoMontage") }}
                                                    </template>
                                                    <svg role="img" class="svg-icon__icon"
                                                         focusable="false" viewBox="0 0 22 22"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"></path>
                                                        <path d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"></path>
                                                    </svg>
                                                </a>
                                            </template>
                                            <template v-else-if="prop.values.selectionId == 304">
                                                <a class="shippinginfo-link"
                                                   data-toggle="modal"
                                                   @click="injectPricesIntoModal()"
                                                   href="#shippinginfo-304">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spedition-no-text"></use>
                                                    </svg>
                                                    {{ $translate("Froschkoenig::Template.shippinginfoMontage") }}
                                                    <svg role="img" class="svg-icon__icon"
                                                         focusable="false" viewBox="0 0 22 22"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"></path>
                                                        <path d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"></path>
                                                    </svg>
                                                </a>
                                            </template>
                                        </template>
                                    </template>

                                    <hr>

                                    <div>
                                        <a href="#"
                                           class="single__more-details"
                                           @click.prevent="toggleHiddenRows()">
                                            {{ $translate("Froschkoenig::Template.singleMoreInfo") }}
                                            <i class="fa fa-chevron-down single__more-info-icon"></i>
                                        </a>
                                    </div>

                                    <div class="row">
                                        <div class="col-9">
                                            <variation-select :item-data="currentVariation" />
                                        </div>
                                    </div>

                                    <div v-if="crossseller.length > 0" class="quick-view__crossseller">
                                        <div class="col-12 col-lg-12 single__variation-selection--variations">
                                            <div class="single__variation-selection--headline">
                                                {{ $translate("Froschkoenig::Template.moreVariations") }}:
                                            </div>
                                            <div class="similar__flex">
                                                <div class="swiper-container single-variations-swiper">
                                                    <div class="swiper-wrapper">
                                                        <div class="swiper-slide" v-for="cross in crossseller">
                                                            <category-item
                                                                    :item-data="cross.data"
                                                                    :key="cross.data.item.id"
                                                                    :firstimagefull="cross.data.images.firstImage.url"
                                                                    :decimal-count="0" size="small"
                                                                    :firstimage="cross.data.images.firstImage.urlPreview">
                                                                <a :href="cross.data | itemURL" class="small">
                                                                    <i class="fa fa-image"></i>
                                                                    <span class="d-none">
                                                                        {{ cross.data | itemName }}
                                                                    </span>
                                                                </a>
                                                            </category-item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="swiper-button-prev swiper-button-prev-variations swiper-button-black">&nbsp;</div>
                                                <div class="swiper-button-next swiper-button-next-variations swiper-button-black">&nbsp;</div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr v-if="crossseller.length > 0 || attributesToCheck.length > 0">

                                    <add-to-basket
                                            :variation-id="currentVariation.variation.id"
                                            :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                            :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                            :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                            :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                            :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                            :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                            :use-large-scale="false"
                                            :show-quantity="true"
                                            :origin="'category'"
                                            :item-data="currentVariation"
                                            :item-url="currentVariation | itemURL"
                                            :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                            :has-price="currentVariation | hasItemDefaultPrice"
                                    >
                                    </add-to-basket>

                                    <a :href="currentVariation | itemURL" class="btn btn-default w-100 mt-3">
                                        {{ $translate("Froschkoenig::Template.quickViewDetails") }}
                                    </a>

                                    <div class="d-none">
                                        <a v-if="currentVariation.item.free3 != '' && currentVariation.item.free3 != null"
                                           target="_blank"
                                           :videoid="currentVariation.item.free3"
                                           class="video-1 d-none"
                                           :href="'https://www.youtube.com/watch?v='+currentVariation.item.free3">
                                            <i class="fa fa-play"></i>
                                            <br/><br/>
                                            <span v-html="$translate('Froschkoenig::Template.playVideo1')"></span>
                                        </a>
                                        <a v-if="currentVariation.item.free14 != '' && currentVariation.item.free14 != null"
                                           target="_blank" :videoid="currentVariation.item.free14"
                                           class="video-2 d-none"
                                           :href="'https://www.youtube.com/watch?v='+currentVariation.item.free14">
                                            <i class="fa fa-play"></i>
                                            <br/><br/>
                                            <span v-html="$translate('Froschkoenig::Template.playVideo2')"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import {get} from "ceres/app/helper/get";
    import ApiService from "ceres/app/services/ApiService";
    import { Swiper } from 'swiper';

    export default {

        data() {
            return {
                showModal: false,
                loadedItem: false,
                item: null
            }
        },

        computed:{
            hasShippingPrices(){
                let hasProps = false;
                for(let key in this.varProps){
                    if([70, 71, 72].includes(this.varProps[key].id)){
                        hasProps = true;
                        break;
                    }
                }
                return hasProps;
            },

            hasPaketOrSpeditionProp(){
                let hasProp = false;
                for(let key in this.varProps){
                    if([302, 301].includes(this.varProps[key].values.selectionId)){
                        hasProp = true;
                        break;
                    }
                }
                return hasProp;
            },

            has304Prop(){
                let hasProp = false;
                for(let key in this.varProps){
                    if([304].includes(this.varProps[key].values.selectionId)){
                        hasProp = true;
                        break;
                    }
                }
                return hasProp;
            },

            hasDeliveryProp72(){
                let hasDeliveryProp72 = false;

                const deliveryPropIds = [72];
                for (let key in this.currentVariation.variationProperties) {
                    for (let innerKey in this.currentVariation.variationProperties[key].properties) {
                        if(deliveryPropIds.includes(this.currentVariation.variationProperties[key].properties[innerKey].id)){
                            hasDeliveryProp72 = true;
                            break;
                        }
                    }
                }

                return hasDeliveryProp72;
            },

            varProps() {
                let propArr = [];
                for (let key in this.currentVariation.variationProperties) {
                    for (let innerKey in this.currentVariation.variationProperties[key].properties) {
                        propArr.push(this.currentVariation.variationProperties[key].properties[innerKey]);
                    }
                }

                return propArr;
            },

            currentVariationSelect() {
                return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationSelect;
            },

            attributesToCheck() {
                return this.currentVariationSelect && this.currentVariationSelect.attributes;
            },

            pluginPathCeres(){
                return App.pluginPathCeres;
            },

            currentVariation() {
                return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
            },

            isVariationSelected() {
                if(this.loadedItem){
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
                }else{
                    return false;
                }
            },

            ...mapState({
                itemId: state => state.quickview.itemId,
                variationId: state => state.quickview.variationId,
                crossseller: state => state.quickview.crossseller,
                attributes: state => state.quickview.attributes,
                variations: state => state.quickview.variations
            })
        },

        watch:{
            itemId(value, oldValue){
                if(value !== oldValue && value !== 0){
                    this.initItem();
                }
            }
        },

        methods: {
            getVarPropShippingValue(typeId){
                let value = "";
                for(let key in this.varProps){
                    if(typeId === this.varProps[key].id){
                        value = this.varProps[key].values.value;
                        break;
                    }
                }

                return parseFloat(value);
            },

            injectPricesIntoModal(){
                // get AT shipping costs
                let itemPrice = this.currentVariation.prices.default.price.value;
                let atShippingPrice = 0;

                if(itemPrice > 1500){
                    atShippingPrice = 149;
                }else if(itemPrice > 500 && itemPrice <= 1500){
                    atShippingPrice = 99;
                }else if(itemPrice > 300 && itemPrice <= 500){
                    atShippingPrice = 49;
                }else if(itemPrice > 150 && itemPrice <= 300){
                    atShippingPrice = 29;
                }else{
                    atShippingPrice = 15;
                }

                if (this.has304Prop || this.hasDeliveryProp72) {
                    atShippingPrice = parseFloat(App.atbasepriceMontage);
                }

                if(document.getElementsByClassName('shippinginfo__receive-at-base').length){
                    const atBases = document.getElementsByClassName('shippinginfo__receive-at-base');
                    for(let key in atBases){
                        if(atBases.hasOwnProperty(key)){
                            atBases[key].innerHTML = atShippingPrice + " €";
                        }
                    }
                }

                if(!!document.querySelector('.shippinginfo__receive-70')){
                    const r70er = document.getElementsByClassName('shippinginfo__receive-70');
                    for(let key in r70er){
                        if(r70er.hasOwnProperty(key)){
                            r70er[key].innerHTML = this.getVarPropShippingValue(70) + " €";
                        }
                    }
                }
                if(!!document.querySelector('.shippinginfo__receive-70-at')){
                    const r70er = document.getElementsByClassName('shippinginfo__receive-70-at');
                    for(let key in r70er){
                        if(r70er.hasOwnProperty(key)){
                            r70er[key].innerHTML = (this.getVarPropShippingValue(70) + 50) + " €";
                        }
                    }
                }
                if(!!document.querySelector('.shippinginfo__receive-72')){
                    const r72er = document.getElementsByClassName('shippinginfo__receive-72');
                    for(let key in r72er){
                        if(r72er.hasOwnProperty(key)){
                            r72er[key].innerHTML = this.getVarPropShippingValue(72) + " €";
                        }
                    }
                }
                if(!!document.querySelector('.shippinginfo__receive-72-at')){
                    const r72er = document.getElementsByClassName('shippinginfo__receive-72-at');
                    for(let key in r72er){
                        if(r72er.hasOwnProperty(key)){
                            r72er[key].innerHTML = (this.getVarPropShippingValue(72) + 50) + " €";
                        }
                    }
                }
            },

            prepareVideoModal(){
                if((this.currentVariation.item.free3 != '' && this.currentVariation.item.free3 != null)){
                    $('#video-modal-wrapper .modal-footer').append('<img class="video-modal-thumb" src="https://img.youtube.com/vi/'+$('.video-1').attr('videoid')+'/1.jpg" videoid="'+$('.video-1').attr('videoid')+'">');
                    $('#video-modal-wrapper').find('iframe').attr('src', 'https://www.youtube.com/embed/'+$('.video-1').attr('videoid')+'?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0')
                }

                if((this.currentVariation.item.free14 != '' && this.currentVariation.item.free14 != null)){
                    $('#video-modal-wrapper .modal-footer').append('<img class="video-modal-thumb" src="https://img.youtube.com/vi/'+$('.video-2').attr('videoid')+'/1.jpg" videoid="'+$('.video-2').attr('videoid')+'">');
                }
            },

            initItem(){
                this.showModal = true;
                let _this = this;

                if(!this.$store.getters[`${this.itemId}/currentItemVariation`]){
                    ApiService.get(window.location.origin+"/rest/fk24/quickview?itemId="+ this.itemId+"&variationId="+ this.variationId)
                        .done(data => {

                            this.$store.dispatch("initVariation", data.item);

                            this.item = data.item.documents[0].data;

                            this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, 0);
                            this.$store.dispatch("addLastSeenItem", this.variationId);

                            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                                itemId:             this.itemId,
                                attributes:         data.variationAttributeMap.attributes,
                                variations:         data.variationAttributeMap.variations,
                                initialVariationId: this.variationId,
                                isPleaseSelectOption: 0,
                                afterKey:           {}
                            });

                            this.$store.commit("setQuickViewAttributes", {[this.itemId] : data.variationAttributeMap.attributes});
                            this.$store.commit("setQuickViewVariations", {[this.itemId] : data.variationAttributeMap.variations});

                            this.loadedItem = true;

                            setTimeout(function(){
                                $('.quick-view__modal').modal("show");
                                _this.initCrossSwiper();
                                _this.prepareVideoModal();
                            }, 250);

                        }).fail((err)=> console.log(err));
                }else{

                    this.$store.dispatch(`${this.itemId}/loadVariation`, this.variationId).then(variation =>
                    {
                        document.dispatchEvent(new CustomEvent("onVariationChanged",
                            {
                                detail:
                                    {
                                        attributes: variation.attributes,
                                        documents: variation.documents
                                    },
                                itemId: this.itemId
                            }));

                        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, 0);
                        this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

                        let attributes = [];
                        for(let key in this.attributes){
                            for(let innerKey in this.attributes[key]){
                                if(parseInt(innerKey) === this.itemId){
                                    attributes = this.attributes[key][innerKey];
                                    break;
                                }
                            }
                        }

                        let variations = [];
                        for(let key in this.variations){
                            for(let innerKey in this.variations[key]){
                                if(parseInt(innerKey) === this.itemId){
                                    variations = this.variations[key][innerKey];
                                    break;
                                }
                            }
                        }

                        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                            itemId:             this.itemId,
                            attributes:         attributes,
                            variations:         variations,
                            initialVariationId:  this.variationId,
                            isPleaseSelectOption: 0,
                        }).then(response =>
                        {

                        });
                    });

                    this.loadedItem = true;
                    setTimeout(function(){
                        $('.quick-view__modal').modal("show");
                        _this.initCrossSwiper();
                    }, 250);
                }
            },

            closeQuickView(target){
                target = target || null;

                if(target === null || target.classList.contains("quick-view__modal")){
                    $('.quick-view__modal').modal("hide");
                    this.showModal = false;
                    this.loadedItem = false;

                    this.$store.commit("setQuickViewItemId", 0);
                    this.$store.commit("setQuickViewVariationId", 0);
                    this.$store.commit("setQuickViewCrossseller", []);

                    $('#video-modal-wrapper .modal-footer').html("");
                    $('#video-modal-wrapper').find('iframe').attr("src", "");
                }

            },

            initCrossSwiper(){
                if (this.loadedItem && this.crossseller.length > 0) {

                    var swipeVariations = new Swiper(".single-variations-swiper", {
                        navigation: {
                            nextEl: '.swiper-button-next-variations',
                            prevEl: '.swiper-button-prev-variations',
                        },
                        spaceBetween: 5,
                        loop: false,
                        slidesPerView: 4,
                        centeredSlides: false,
                        breakpointsInverse: true,
                        breakpoints: {
                            991: {
                                allowTouchMove: false,
                                slidesPerView: 5
                            }
                        }
                    });
                }
            },

            toggleHiddenRows(){

                $(".single__details-table tr.toggle-hidden").toggleClass("hidden");

                if ($(".single__more-info-icon").hasClass("fa-chevron-down")) {
                    $(".single__more-info-icon").removeClass("fa-chevron-down");
                    $(".single__more-info-icon").addClass("fa-chevron-up");
                } else {
                    $(".single__more-info-icon").addClass("fa-chevron-down");
                    $(".single__more-info-icon").removeClass("fa-chevron-up");
                }
            }
        }
    }
</script>
